import * as React from "react";
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils.js";

/**
 * Badge variant styles configuration
 */
const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground transition-colors hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground transition-colors hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground transition-colors hover:bg-destructive/80",
        outline: "text-foreground",
        /** Status pills — colors from getStatusBadgeClass; no hover wash */
        status: "",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

/**
 * Badge component for displaying status indicators and labels
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @param {'default'|'secondary'|'destructive'|'outline'|'status'} [props.variant] - Badge variant style
 * @param {...Object} props - Other HTML div attributes
 * @returns {JSX.Element} Badge component
 */
/** @param {{ className?: string, variant?: 'default'|'secondary'|'destructive'|'outline'|'status', children?: React.ReactNode, [key: string]: any }} props */
function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
